const showNode = (node) => {
  if (node == null) {
    return;
  }

  node.style.display = 'block';
  return node;
};

const hideNode = (node) => {
  if (node == null) {
    return;
  }

  node.style.display = 'none';
  return node;
};

const isSafari = () => {
  if (/apple/i.test(navigator.vendor)) {
      return true
  }

  return false
}

const isFirefox = () => {
  return navigator.userAgent.indexOf('Firefox') > -1
}

export {
  showNode,
  hideNode,
  isSafari,
  isFirefox,
};
